import React, { useCallback, useRef, useState } from "react";
import FormPageHeader from "../utilities/FormPageHeader";
import { useNavigate } from "react-router-dom";
import { Button, Divider, FormControl, Grid, IconButton, Stack, TextField, Tooltip } from "@mui/material";
import CustomDatePicker from "../utilities/CustomDatePicker";
import moment from "moment";
import * as Flags from 'country-flag-icons/react/3x2'
import AgGridTable from "../utilities/AgGridTable";
import { Box } from "@mui/system";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import EditCreatedProformaInvoice from "./EditCreatedProformaInvoice";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { useEffect } from "react";
import OAuthService from "src/app/auth/services/oAuthService";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";

const AddProformaInvoice = () => {
    const navigate = useNavigate();
    const revisiongridRef = useRef();
    const gridRef = useRef();
    const createPIRef = useRef();
    const [error, setError] = useState();
    const [successMsg, setSuccessMsg] = useState();
    const [company, setCompany] = useState();
    const [customer, setCustomer] = useState();
    const [loadingWeek, setLoadingWeek] = useState();
    const [containerNumber, setContainerNumber] = useState();
    const [INTLContainerNumber, setINTLContainerNumber] = useState();
    const [territory, setTerritory] = useState();
    const [country, setCountry] = useState();
    const [fromDate, setFromDate] = useState();
    const [toDate, setToDate] = useState();
    const [snackState, setSnackState] = useState(false);
    const [proformaCreated, setProformaCreated] = useState(false);
    const [saveDisable, setSaveDisable] = useState(true);
    const [showEditPI, setShowEditPI] = useState(false);
    const [editPIData, setEditPIData] = useState();
    const [showViewPI, setShowViewPI] = useState(false);
    const [saveAndSaveDisable, setSaveAndSaveDisable] = useState(true);
    const [fromError, setFromError] = useState();
    const [toError, setToError] = useState();
    const [territoryOptions, setTerritoryOptions] = useState();
    const [countryOptions, setCountryOptions] = useState();
    const [customerOptions, setCustomerOptions] = useState();
    const [readyPItotal, setReadyPItotal] = useState(0);
    const [createPITotal, setCreatePITotal] = useState(0);
    const [revisionTotal, setRevisiontotal] = useState(0);
    const [readyRowData, setReadyRowData] = useState()
    const [allReadyPIData, setAllReadyPIData] = useState([])
    const [createPIRowData, setCreatePIRowData] = useState([])
    const [revisionRowData, setRevisionRowData] = useState([])
    const [selectedRows, setSelectedRows] = useState([]);

    const renderCurrency = (props) => {
        return <span style={{ display: "flex" }}>
            <p>{props?.value && new Intl.NumberFormat('en-US').format(props?.value)}</p>
        </span>;
    };

    const [readyPIColumnDefs, setReadyPIColumnDefs] = useState([
        {
            field: 'internalContainerNo', headerName: 'INTL Container No', dndSource: (params) =>
                params.data.orderCategory !== "" && params.data.paymentTerm !== "",
        },
        { field: 'loadingPlanDate', headerName: 'Loading Plan Date', },
        { field: 'loadingPlanWeek', headerName: 'Loading Plan Week', },
        { field: 'grandTotal', headerName: 'PI Value', cellRenderer: renderCurrency },
        { field: 'orderCategory', headerName: 'orderCategory', hide: 'true' },
        { field: 'paymentTerm', headerName: 'paymentTerm', hide: 'true' },

    ])

    const handleEditRender = useCallback((props) => {
        // const allContainerData = allReadyPIData.filter((pi) => pi.internalContainerNo === props.data.internalContainerNo)
        const editData = {
            ...props.data,
            // detailData:allContainerData
        }
        return <>
            <IconButton size={'small'} onClick={() => { setShowEditPI(true); setEditPIData(props.data) }}>
                <FuseSvgIcon size={18}>heroicons-solid:pencil</FuseSvgIcon>
            </IconButton>

            <IconButton size={'small'} onClick={() => { setShowViewPI(true); setEditPIData(props.data) }}>
                <FuseSvgIcon size={18}>heroicons-solid:eye</FuseSvgIcon>
            </IconButton>

        </>
    }, [allReadyPIData])

    const [createPIColumnDefs, setCreatePIColumnDefs] = useState([
        {
            field: 'piNumber', headerName: 'PI NO',
            // dndSource: (params) =>
            // params.data.piNumber !== "" && params.data.piNumber !== undefined && params.data.piNumber !== null,
        },
        { field: 'orderCategory', headerName: 'Order Type', },
        { field: 'internalContainerNo', headerName: 'INTL Container No', },
        { field: 'loadingPlanDate', headerName: 'Loading Plan Date', },
        { field: 'loadingPlanWeek', headerName: 'Loading Plan Week', },
        { field: 'grandTotal', headerName: 'PI Value', cellRenderer: renderCurrency },
        { field: 'view/edit', headerName: 'View/Edit', minWidth: 150, cellRenderer: handleEditRender },
        // { field: 'view', headerName: 'View', cellRenderer: ViewCreatedProformaInvoice },
    ])

    const PIurl = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.ProformaInvoice}`;

    const [revisionPIColumnDefs, setRevisionPIColumnDefs] = useState([
        { field: 'piNumber', headerName: 'PI NO' },
        { field: 'orderType', headerName: 'Order Type', },
        { field: 'internalContainerNo', headerName: 'INTL Container No', },
        { field: 'loadingPlanDate', headerName: 'Loading Plan Date', },
        { field: 'loadingPlanWeek', headerName: 'Loading Plan Week', },
        { field: 'value', headerName: 'PI Value', cellRenderer: renderCurrency },
        { field: 'revisedValue', headerName: 'Revised Value', },
        { field: 'revised', headerName: 'Revised', cellRenderer: revisedPI },
    ])

    function revisedPI(props) {
        return <>
            <Tooltip title={"Revised PI"}>
                <IconButton size="small" onClick={() => handleRevisedPI(props.data)}>
                    <FuseSvgIcon size={15}>material-solid:autorenew</FuseSvgIcon>
                </IconButton>
            </Tooltip>
        </>
    }

    const handleRevisedPI = async (data) => {
        const model = {
            "piNumber": data.piNumber,
            requestId: data.id,
            sendEmail:true
        }
        try {
            await OAuthService.putData(PIurl + '/approvePiRevision', model);
            setSuccessMsg("PI revised successfully.")
            setSnackState(true);
            loadRevisionPIData();
        } catch (error) {
            setError(error.message);
        }
    }

    const loadReadyProformaInvoiceData = async () => {
        gridRef?.current?.api?.showLoadingOverlay();
        try {
            const list = await OAuthService.getList(PIurl + '/getallreadyforpiorders');

            let data = list.data;
            setAllReadyPIData(data);
            let filtered = [];
            const filter = JSON.parse(JSON.stringify(data))
            if (filter.length > 0) {
                filter.map((val) => {
                    const index = filtered.findIndex(o => o.internalContainerNo === val.internalContainerNo);
                    if (index >= 0) {
                        filtered[index].grandTotal = (filtered[index]?.grandTotal ? filtered[index]?.grandTotal : 0) + Number(val?.grandTotal);
                    } else {
                        filtered.push(val)
                    }
                    return val;
                })
            }
            gridRef?.current?.api?.hideOverlay();
            setReadyRowData(filtered);
            setError('')
        } catch (error) {
            gridRef?.current?.api?.hideOverlay();
            setError(error.message);
            setReadyRowData([])
        }
    };

    useEffect(() => {
        let pitotal = 0;
        (readyRowData && readyRowData.length > 0 ) && readyRowData.map((val) => {
            if (val?.grandTotal) {
                pitotal = pitotal + Number(val?.grandTotal)
            }
        });
        setReadyPItotal(new Intl.NumberFormat('en-US').format(pitotal))
    }, [readyRowData])

    useEffect(() => {
        let pitotal = 0;
        createPIRowData.map((val) => {
            if (val?.grandTotal) {
                pitotal = pitotal + Number(val?.grandTotal)
            }
        });
        setCreatePITotal(new Intl.NumberFormat('en-US').format(pitotal))
    }, [createPIRowData])

    useEffect(() => {
        let pitotal = 0;
        revisionRowData.map((val) => {
            if (val?.value) {
                pitotal = pitotal + Number(val?.value)
            }
        });
        setRevisiontotal(new Intl.NumberFormat('en-US').format(pitotal))
    }, [revisionRowData])

    const loadRevisionPIData = async() => {
        try {
            const list = await OAuthService.getList(PIurl + '/piRevisionRequests');

            let data = list.data;
            setRevisionRowData(data);
            setError('')
        } catch (error) {
            setError(error.message);
        }
    }

    useEffect(() => {
        loadReadyProformaInvoiceData();
        loadRevisionPIData();
        const territories = async () => {
            const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.territory}?size=1000`;
            const territories = await OAuthService.getList(url);

            const result = territories?.data?._embedded.territories.map((value) => {
                return { label: value.displayName, value: value?.id, id: value?.id }
            })
            setTerritoryOptions(result);
        }
        territories();

        const countries = async () => {
            const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.country}?size=1000`;
            const countries = await OAuthService.getList(url);

            const result = countries?.data?._embedded.countries.map((value) => {
                const Flag = Flags[value.isoCode];
                return { label: value.name, value: value.name, code: value.isoCode, icon: value.isoCode && <Flag width={18} style={{ marginInline: "5px" }} /> }
            })
            setCountryOptions(result);
        }
        countries();

        const customers = async () => {
            const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}?size=1000`;
            const customers = await OAuthService.getList(url);

            const result = customers?.data?._embedded.companies.map((value) => {
                return { label: value.name, value: value.id }
            })
            setCustomerOptions(result);
        }
        customers();

    }, [])

    const handleCancel = () => {
        navigate('/proformaInvoice');
    }

    const handleChangeCompany = (event) => {
        setCompany(event.target.value)
    }

    const handlechangeCustomer = (event) => {
        setCustomer(event.value)
    }

    const handleChangeContainer = (event) => {
        setContainerNumber(event.target.value)
    }

    const handleChangeCountry = (event) => {
        setCountry(event.value)
    }

    const handleChangeINTLcontainer = (event) => {
        setINTLContainerNumber(event.target.value)
    }

    const handleChangeTerritory = (event) => {
        setTerritory(event.value)
    }

    const handleChangeLoadingWeek = (event) => {
        setLoadingWeek(event.target.value)
    }

    const handleFromDateChange = (value) => {
        setFromDate(value === null ? null : moment(value).format('YYYY-MM-DD'));
        value && setToDate(null);
    }

    const handleToDateChange = async (value) => {
        const endDate = value === null ? null : moment(value).format('YYYY-MM-DD');
        setToDate(endDate);
        (!fromDate && endDate) ? setFromError('Please select from date ') : setFromError('');
    }

    const handleSubmit = async () => {
        let submitData = JSON.parse(JSON.stringify(createPIRowData));
        let model = submitData[0]?.internalContainerNo
        await OAuthService.addData(PIurl + '/generateproformainvoice', { "containerNumList": [model],  "sendEmail": false,
        "withStamp": false,
        "withSign": false });

        setSuccessMsg("Data saved Successfully")
        setSnackState(true);
        setTimeout(() => { navigate('/proformaInvoice') }, 800)
    }

    const onSelectionChanged = (params) => {
        setSelectedRows(params.api.getSelectedRows());
        setSaveDisable(false)
        setSaveAndSaveDisable(false)

    }

    const handleSaveAndSend = async () => {
        try {
            let submitData = JSON.parse(JSON.stringify(createPIRowData));
            let model = submitData[0]?.internalContainerNo;
            await OAuthService.addData(PIurl + '/generateproformainvoice', { "containerNumList":  [model], "sendEmail": true ,
            "withStamp": true,
            "withSign": true });

            setSuccessMsg("Data saved Successfully")
            setSnackState(true);
            setTimeout(() => { navigate('/proformaInvoice') }, 800)
        } catch (error) {
            setError(error.message);
        }
    }

    function dragover_handler(ev) {
        ev.preventDefault();
        ev.dataTransfer.dropEffect = "move";
    }
    
    function drop_handler(ev, box, id) {
        ev.preventDefault();
        const data = JSON.parse(ev.dataTransfer.getData("text/plain"));
        if (id === "createPI") {
            const allContainerData = allReadyPIData.filter((pi) => pi.internalContainerNo === data.internalContainerNo)
            let transaction = {
                add: allContainerData,
            };
            setCreatePIRowData((prevData) => [...prevData, ...transaction.add]);
            setReadyRowData((prevData) => prevData.filter((item) => item.orderId !== data.orderId));
        }
        if (id === "revisionPI") {
            let transaction = {
                add: [data],
            };
            setRevisionRowData((prevData) => [...prevData, ...transaction.add]);
            setCreatePIRowData((prevData) => prevData.filter((item) => item.orderId !== data.orderId));
        }
    };


    const loadPINumber = async () => {
        const url = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.ProformaInvoices}`;
        const list = await OAuthService.getList(url + `/search/findAllByInternalContainerNoIn?containerNums=${editPIData.internalContainerNo}`)
        const piNumber = list?.data?._embedded?.proformaInvoices[0]?.piNumStr
        if (piNumber) {
            const updatedRowData = createPIRowData?.map((data) => {
                if (data.internalContainerNo === editPIData.internalContainerNo) {
                    data.piNumber = piNumber
                }
                return data
            })
            setCreatePIRowData(updatedRowData)
        }
    }

    useEffect(() => {
        if (proformaCreated) {
            loadPINumber();
            loadRevisionPIData();
        }
    }, [proformaCreated])

    const handleEditForm = (status) => {
        setShowEditPI(status);
        if (!status) {
            setShowViewPI(status)
        }
    }

    useEffect(() => {
        handleEditForm();
        handleSuccessMsg();
        handleError()
        handleNewProforma()
    }, []);

    const handleError = (msg) => {
        setError(msg)
    }
    const handleNewProforma = (msg) => {
        setProformaCreated(msg)
    }

    const handleSuccessMsg = (msg) => {
        if (msg) {
            setSuccessMsg(msg)
            setSnackState(true)
        } else {
            setSnackState(false)
        }
    }

    const getSearchReadyPIorders = async () => {
        gridRef?.current?.api?.showLoadingOverlay();
        let filterValue = {};
        if (territory) {
            filterValue = { ...filterValue, territory: territory };
        }
        if (company) {
            filterValue = { ...filterValue, company: company };
        }
        if (customer) {
            filterValue = { ...filterValue, customer: customer };
        }
        if (loadingWeek) {
            filterValue = { ...filterValue, loadingWeek: loadingWeek };
        }
        if (containerNumber) {
            filterValue = { ...filterValue, containerNumber: containerNumber };
        }
        if (INTLContainerNumber) {
            filterValue = { ...filterValue, intlContainerNum: INTLContainerNumber };
        }
        if (country) {
            filterValue = { ...filterValue, country: country };
        }
        if (toDate) {
            filterValue = { ...filterValue, toDate: toDate };
        }
        if (fromDate) {
            filterValue = { ...filterValue, fromDate: fromDate };
        }
        try {
            const list = await OAuthService.addData(PIurl + `/filterReadyToPiOrders`, filterValue)
            let data = list.data;
            setAllReadyPIData(data);
            let filtered = [];
            const filter = JSON.parse(JSON.stringify(data))
            if (filter.length > 0) {
                filter.map((val) => {
                    const index = filtered.findIndex(o => o.internalContainerNo === val.internalContainerNo);
                    if (index >= 0) {
                        filtered[index].grandTotal = (filtered[index]?.grandTotal ? filtered[index]?.grandTotal : 0) + Number(val?.grandTotal);
                    } else {
                        filtered.push(val)
                    }
                    return val;
                })
            }
            gridRef?.current?.api?.hideOverlay();
            setReadyRowData(filtered);
            setError('')
        } catch (error) {
            gridRef?.current?.api?.hideOverlay();
            setError(error.message);
            setReadyRowData([])
        }
    }

    useEffect(() => {
        if (territory || company || fromDate || toDate || customer || loadingWeek || INTLContainerNumber || containerNumber || country) {
            getSearchReadyPIorders()
        } else {
            loadReadyProformaInvoiceData()
        }

    }, [company, fromDate, toDate, customer, loadingWeek, INTLContainerNumber, country, territory, containerNumber])

    const clearAllFilter = () => {
        setCompany('');
        setFromDate('');
        setToDate('');
        setCustomer('');
        setCountry('');
        setTerritory('');
        setLoadingWeek('');
        setINTLContainerNumber('');
    }

    return (
        <>
            <FormPageHeader
                currentPage={"Add Proforma Invoice"}
                componentName={"AddProformaInvoice"}
                handleSubmit={handleSubmit}
                saveAndSend={handleSaveAndSend}
                error={error}
                successMsg={successMsg}
                snackState={snackState}
                saveDisable={createPIRowData.length > 0 ? createPIRowData.filter((data) => !data.piNumber || (data.piNumber === null || data.piNumber === '')).length > 0 ? false :true : true}
                saveAndSaveDisable={createPIRowData.length > 0 ? createPIRowData.filter((data) => !data.piNumber || (data.piNumber === null || data.piNumber === '')).length > 0 ? false :true : true}
                handleCancel={handleCancel}
            // showLedgersList={DrawerOpen}
            />

            <Stack direction={'row'} className="mb-10 md:px-16 self-end ">
                <div className="flex flex-row">
                    <div className="flex flex-row justify-between items-baseline">

                        <Stack className="ml-10">
                            <label className="pt-12 min-w-fit">Company</label>
                            <TextField
                                name='company'
                                value={company}
                                onChange={handleChangeCompany}
                                inputProps={{
                                    sx: { 'padding': '10px' },
                                }}
                            />
                        </Stack>

                        <Stack className="ml-10">
                            <label className="pt-12 min-w-fit">Customer</label>
                            <Select name="country"
                                value={(customer && customerOptions) && customerOptions.filter(obj => customer === obj.value)}
                                onChange={handlechangeCustomer}
                                options={customerOptions}
                                styles={customStyles()}
                                className="select w-[250px]"
                            />
                        </Stack>

                        <Stack className="ml-10">
                            <label className="pt-12 min-w-fit">Loading Week</label>
                            <TextField
                                name='loading_week'
                                value={loadingWeek}
                                onChange={handleChangeLoadingWeek}
                                inputProps={{
                                    sx: { 'padding': '10px' },
                                }}
                            />
                        </Stack>

                        <Stack className="ml-10">
                            <label className="pt-12 min-w-fit">Container Number</label>
                            <TextField
                                name='contanier_number'
                                value={containerNumber}
                                onChange={handleChangeContainer}
                                inputProps={{
                                    sx: { 'padding': '10px' },
                                }}
                            />
                        </Stack>

                        <Stack className="ml-10">
                            <label className="pt-12 min-w-fit">INTL Container No </label>
                            <TextField
                                name='intl_contanier_number'
                                value={INTLContainerNumber}
                                onChange={handleChangeINTLcontainer}
                                inputProps={{
                                    sx: { 'padding': '10px' },
                                }}
                            />
                        </Stack>

                        <Stack className="ml-10">
                            <label className="pt-12 min-w-fit">Territory</label>
                            <Select name="country"
                                value={(territory && territoryOptions) && territoryOptions.filter(obj => territory === obj.value)}
                                onChange={handleChangeTerritory}
                                options={territoryOptions}
                                styles={customStyles()}
                                className="select w-[150px]"
                            />
                        </Stack>

                        <Stack className="ml-10">
                            <label className="pt-12 min-w-fit">Country</label>
                            <Select name="country"
                                value={(country && countryOptions) && countryOptions.filter(obj => country === obj.value)}
                                onChange={handleChangeCountry}
                                options={countryOptions}
                                styles={customStyles()}
                                className="select w-[150px]"
                                getOptionLabel={e => (
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        {e.icon}
                                        <span style={{ marginLeft: 5 }}>{e.label}</span>
                                    </div>
                                )}
                            />
                        </Stack>

                        <Stack className="ml-10">
                            <label className="min-w-fit">From </label>
                            <div className="grid">
                                <CustomDatePicker
                                    className="w-[150px] h-[20px]"
                                    format={'dd-MM-yyyy'}
                                    name={'fromDate'}
                                    value={fromDate}
                                    handleChange={handleFromDateChange}
                                    componentsProps={{
                                        actionBar: { actions: ["clear"] },
                                    }}
                                    renderInput={(params) => <TextField size="small" InputLabelProps={{
                                    }} {...params} sx={{
                                        backgroundColor: props.viewData && '#8080800f'
                                    }} />}
                                />
                                <p className="text-red">{(fromError && !fromDate) && fromError}</p>
                            </div>
                        </Stack>
                        <Stack className="ml-10">
                            <label className="min-w-fit">To </label>
                            <div className="grid">
                                <CustomDatePicker
                                    className="w-[150px] h-[20px]"
                                    format={'dd-MM-yyyy'}
                                    name={'toDate'}
                                    value={toDate}
                                    minDate={new Date(fromDate)}
                                    handleChange={handleToDateChange}
                                    componentsProps={{
                                        actionBar: { actions: ["clear"] },
                                    }}
                                    renderInput={(params) => <TextField size="small" InputLabelProps={{
                                    }} {...params} sx={{
                                        backgroundColor: props.viewData && '#8080800f'
                                    }} />}
                                />
                                <p className="text-red">{(toError && !toDate) && toError}</p>
                            </div>
                        </Stack>
                        <Stack className="ml-10 self-end">
                            <Tooltip title="Clear Filter">
                                <Button
                                    variant="contained"
                                    color="warning"
                                    style={{ marginLeft: "9px" }}
                                    onClick={clearAllFilter}
                                    size="small"
                                ><FuseSvgIcon >material-solid:search_off</FuseSvgIcon></Button>
                            </Tooltip>
                        </Stack>
                    </div>
                </div>
            </Stack>

            <Divider className="mt-8" />
            {/* <div> */}
            <div className="flex flex-col sm:flex-row flex-1 w-full justify-between p-10 overflow-x-auto gap-x-20" >

                <div className="flex-[0_0_40%]">
                    <label className="text-lg font-bold mb-10">Ready For PI</label>
                    <Box
                        id="target"

                        onDragOver={(event) => dragover_handler(event)}
                    >
                        <div className="h-[500px]">
                            <AgGridTable
                                columnDefs={readyPIColumnDefs}
                                editable={false}
                                rowData={readyRowData}
                                onSelectionChanged={onSelectionChanged}
                                groupRowMinWidth={250}
                                hideCheckbox={true}
                                rowGroupPanelShow='never'
                                showSidebar={false}
                                autoHeaderHeight={true}
                                wrapHeaderText={true}
                                gridRef={gridRef}
                            />
                            <div className="flex justify-end items-baseline mt-8 ">
                                <label className="mr-8" >Total</label>
                                <TextField
                                    name="total"
                                    disabled
                                    value={readyPItotal}
                                    inputProps={{
                                        sx: { 'width': '150px' },
                                    }} />
                            </div>
                        </div>
                    </Box>
                </div>

                <div className="flex-[0_0_40%]">
                    <label className="text-lg font-bold mb-10">Create PI</label>
                    <Box
                        id="createPI"
                        onDrop={(event) => drop_handler(event, "container-right", "createPI")}
                        onDragOver={(event) => dragover_handler(event)}
                    >
                        <div className="h-[500px]">
                            <AgGridTable
                                columnDefs={createPIColumnDefs}
                                editable={false}
                                rowData={createPIRowData}
                                groupRowMinWidth={250}
                                hideCheckbox={true}
                                rowGroupPanelShow='never'
                                showSidebar={false}
                                autoHeaderHeight={true}
                                wrapHeaderText={true}
                                gridRef={createPIRef}
                                rowSelection={"multiple"}
                            />
                            <div className="flex justify-end items-baseline mt-8">
                                <label className="mr-8" >Total</label>
                                <TextField
                                    name="total"
                                    disabled
                                    value={createPITotal}
                                    inputProps={{
                                        sx: { 'width': '150px' },
                                    }} />
                            </div>
                        </div>
                    </Box>
                </div>

                <div className="flex-[0_0_40%]">
                    {/* <div className="flex justify-center">
                    <FuseSvgIcon>material-outline:arrow_downward</FuseSvgIcon>
                </div> */}
                    <label className="text-lg font-bold mb-10">PI REVISION</label>
                    <Box
                        id="revisionPI"
                        // onDrop={(event) => drop_handler(event, "container-right", "revisionPI")}
                        onDragOver={(event) => dragover_handler(event)}
                    >
                        <div className="h-[500px]">
                            <AgGridTable
                                columnDefs={revisionPIColumnDefs}
                                editable={false}
                                rowData={revisionRowData}
                                groupRowMinWidth={250}
                                hideCheckbox={true}
                                rowGroupPanelShow='never'
                                showSidebar={false}
                                autoHeaderHeight={true}
                                wrapHeaderText={true}
                                gridRef={revisiongridRef}
                            />
                            <div className="flex justify-end items-baseline mt-8">
                                <label className="mr-8" >Total</label>
                                <TextField
                                    name="total"
                                    disabled
                                    value={revisionTotal}
                                    inputProps={{
                                        sx: { 'width': '150px' },
                                    }} />
                                {/* <Tooltip title={"Revised All PI"}>
                                    <Button

                                        variant="contained"
                                        color="warning"
                                        style={{ marginLeft: "9px" }}
                                        onClick={revisedAllPI}
                                        size="small"
                                    >
                                        <FuseSvgIcon>material-solid:autorenew</FuseSvgIcon>
                                    </Button>

                                </Tooltip> */}
                            </div>

                        </div>
                    </Box>
                </div>

            </div>
            {(showEditPI || showViewPI) && <EditCreatedProformaInvoice
                editData={editPIData} editPI={showEditPI} viewPI={showViewPI} error={handleError}
                proformaCreated={handleNewProforma}
                successMsg={handleSuccessMsg}
                handleEditForm={handleEditForm} />}

        </>

    )
}

export default AddProformaInvoice